import { render, staticRenderFns } from "./mobileTabs.vue?vue&type=template&id=625c18e0&scoped=true&"
import script from "./mobileTabs.vue?vue&type=script&lang=js&"
export * from "./mobileTabs.vue?vue&type=script&lang=js&"
import style0 from "./mobileTabs.vue?vue&type=style&index=0&id=625c18e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c18e0",
  null
  
)

export default component.exports